export default abstract class BaseComponent {
    constructor(protected view: HTMLElement) {
        this.view = view;
        this.initAdditionalVar();
        this.init();
    }

    protected abstract init(): void;

    protected initAdditionalVar(): void {}

    /**
     * La fonction debounce permet de déclencher l'appel à une fonction après un certain délai
     * (un peu comme la fonction setTimeout()) mais permet en plus de réinitialiser le timer si on
     * demande une nouvelle exécution dans un intervalle de temps plus court que le délai.
     * Par exemple, on peut écouter la frappe d'un utilisateur dans un champ texte, mais ne pas vouloir
     * appeler notre callback seulement si l'utilisateur marque une pause suffisamment longue.
     *
     * @see https://grafikart.fr/tutoriels/debounce-throttle-642
     * @private
     * @param func
     * @param waitFor
     */
    protected debounce<F extends(...args: Parameters<F>) => ReturnType<F>>
    (func: F, waitFor: number): (...args: Parameters<F>) => void {
        // eslint-disable-next-line no-undef
        let timeout: NodeJS.Timeout;
        return (...args: Parameters<F>): void => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), waitFor);
        };
    }
}
